import React from 'react';
import PropTypes from 'prop-types';
import {I18nContext, I18nManager} from '@shopify/react-i18n';
import railsData from 'utilities/rails-data';

const locale = railsData('locale') || 'en';

export default function I18nProvider({children}) {
  const i18nManager = new I18nManager({locale});

  return (
    <I18nContext.Provider value={i18nManager}>{children}</I18nContext.Provider>
  );
}

I18nProvider.propTypes = {
  children: PropTypes.oneOfType([
    PropTypes.array,
    PropTypes.element,
    PropTypes.string,
  ]),
};
